import { Hash } from 'lucide-react'

/**
 * Story 3.16.1 — Display read-only para settings numéricas simples
 * (count, max-tokens, prompt-max-chars). Renderiza número + opcional
 * unidade (singular/plural automático).
 */
export function NumberDisplay({
  value,
  unitSingular,
  unitPlural,
}: {
  value: unknown
  unitSingular?: string
  unitPlural?: string
}): React.ReactElement {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return <code className="text-xs text-muted-foreground">(valor inválido)</code>
  }
  const unit = pickUnit(value, unitSingular, unitPlural)
  return (
    <div className="flex items-center gap-2 text-sm">
      <Hash className="h-3.5 w-3.5 text-muted-foreground" aria-hidden="true" />
      <span>
        <span className="font-medium">{formatNumber(value)}</span>
        {unit !== null && <span className="ml-1 text-muted-foreground">{unit}</span>}
      </span>
    </div>
  )
}

function pickUnit(
  value: number,
  singular?: string,
  plural?: string,
): string | null {
  if (singular === undefined && plural === undefined) return null
  if (value === 1 && singular !== undefined) return singular
  return plural ?? singular ?? null
}

function formatNumber(value: number): string {
  // Insere separador de milhar pt-BR (1000 → "1.000")
  return new Intl.NumberFormat('pt-BR').format(value)
}
